import React, { useCallback } from "react";
import { RuleSource } from "@common/types/transactionRule";
import { Button } from "@design-system/Button/Button";
import { useToaster } from "@design-system/ToastMessages/useToaster";
import { useOverlays } from "contexts/OverlayContext";
import { HStack } from "@design-system/HStack/HStack";
import styles from "./SuggestTransactionRuleToast.module.scss";
import { InheritedRuleSuggestion } from "./buildInheritedRuleSuggestion";

export const SuggestTransactionRuleToast: React.FC<{
    suggestion: InheritedRuleSuggestion;
    toastId: string;
}> = ({ suggestion, toastId }) => {
    const { openOverlay } = useOverlays();
    const { dismiss } = useToaster();

    const onReview = useCallback(() => {
        openOverlay("createRule", {
            definition: suggestion.definition,
            source: RuleSource.TRANSACTIONS_FEED,
            groupType: suggestion.groupType,
        });
        dismiss(toastId);
    }, [dismiss, openOverlay, suggestion, toastId]);

    return (
        <div className={styles.message}>
            <p>Use this change in a rule?</p>
            <HStack as="footer" justify="end">
                <Button variant="primary" size="md" onClick={onReview}>
                    Create rule
                </Button>
            </HStack>
        </div>
    );
};
